import { Avatar, Box, Card, CardContent, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2, IconButton, InputLabel, MenuItem, Pagination, Paper, Select, Snackbar, Tab, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from "@mui/material"
import '../jobPostings/jobpostings.css';
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import { useContext, useEffect, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import MUIButton from "../../reusable_components/components/MUIButton";
import MuiDatePicker from "../../reusable_components/components/MuiDatePicker"
import CalendarIcon from "../../assets/Icons/CalendarIcon";
import Dropdown from "../../reusable_components/components/Dropdown";
import * as Yup from 'yup'
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useReferralCommissionApprovalMutation, useReferralCommissionsDetailsMutation, useReferralPaymentListMutation, useSaveReferralPaymentMutation } from "../../redux/ReferralPayment/ViewJobPayment.api";
import dayjs from "dayjs";
import { TableLoader } from "../../reusable_components/components/TableLoader";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import DoneIcon from '@mui/icons-material/Done';
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import { useSelector } from "react-redux";


const ViewPayments = () => {

    const navigate = useNavigate()
    const { Snackbar } = useContext(SnackbarContext)

    const { Profile } = useSelector((state) => state?.common)
    const userRole = Profile?.profile?.role

    const location = useLocation()

    const { positionName, recruiterId, recruitersName, recruiterEmail, positionId,
        clientId, clientName } = location?.state || ''

    const [showTableLoader, setShowTableLoader] = useState(false)


    const [CommissionDetails, setCommissionDetails] = useState([])
    const [count, setCount] = useState(0)
    const [page, setPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)

    const [approveReferralCommission] = useReferralCommissionApprovalMutation()
    const [referralPayment, setReferralPayment] = useState([])

    const [ViewJobCommissions] = useReferralCommissionsDetailsMutation();
    const [viewReferralPaymentList] = useReferralPaymentListMutation();
    const [paymentRefund] = useSaveReferralPaymentMutation();

    const validationSchema = Yup.object().shape({
        jobPosition: Yup.string().required("Job position is required"),
    })

    const resolver = yupResolver(validationSchema)

    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        reset,
        watch,
    } = useForm({
        mode: 'onChange',
        resolver,
        defaultValues: {
            jobPosition: "",
        }
    })

    const [paymentDialogOpen, setPaymentDialogOpen] = useState(false)
    const [CommissionDialogOpen, setCommissionsDialogOpen] = useState(false)
    const [MinihistoryDialogOpen, setMinihistoryDialogOpen] = useState(false)
    const [referralTypeOpen, setReferralTypeOpen] = useState(false);
    const [refundList, setRefundList] = useState([]);


    const [JoiningDate, setJoiningDate] = useState(null)
    const [selectedIds, setSelectedIds] = useState([]);
    const [rejectReason, setRejectReason] = useState('');
    const [triggerApi, setTriggerApi] = useState(false)


    const handleReject = (event) => {
        setRejectReason(event.target.value); // Update state with input value
    };

    const handleCheckboxChange = (id) => {
        setSelectedIds((prevSelected = []) => // Add default array
            prevSelected.includes(id)
                ? prevSelected.filter((selectedId) => selectedId !== id) // Remove
                : [...prevSelected, id] // Add
        );
    };

    const handleOpenPaymentDialog = () => {
        setPaymentDialogOpen(true)
    }

    const handleOpenCommissions = () => {
        setCommissionsDialogOpen(true)
    }

    const hanldeMiniDialogOpen = async (item) => {
        setRefundList(item)
        setMinihistoryDialogOpen(true)
        try {
            const payload = {
                referralCommissionId: item?.referralCommissionId
            }
            const response = await viewReferralPaymentList(payload).unwrap();
            setReferralPayment(response?.response)

        } catch (error) {
            Snackbar("Network error", 'error')
        }
    }

    const handleClose = () => {
        setPaymentDialogOpen(false)
        setCommissionsDialogOpen(false)
        setReferralTypeOpen(false)
        setMinihistoryDialogOpen(false)
    }

    const handleCandidateDate = (value) => {
        setJoiningDate(value)
    }

    const handleNavigation = () => {
        // navigate('/referral-payments')
        navigate(-1)
    }

    const [value, setValues] = useState('1');

    const handleChange = (event, newValue) => {
        setValues(newValue);
    };

    const handleChangePage = (e, newPage) => {
        setPage(newPage)
        setTriggerApi(true)
    }

    const getCommissionDetails = async () => {
        try {
            const payload = {
                page: page ? page - 1 : 0,
                size: rowsPerPage ? rowsPerPage : 10,
                positionId: positionId,
                referralType: "JOB-REF",
                status: null,
            }
            setShowTableLoader(true)
            const response = await ViewJobCommissions(payload).unwrap()
            setShowTableLoader(false)
            setCommissionDetails(response?.response?.referralCommissionDetails)
            setCount(response?.response?.totalElements)

        } catch (error) {
            Snackbar("Network error", 'error')
        }
    }

    useEffect(() => {
        getCommissionDetails()
    }, [])

    const approveReferral = async (item) => {
        try {
            const params = {
                referralCommissionId: item?.referralCommissionId,
            }
            const response = await approveReferralCommission(params).unwrap()
            Snackbar(response?.response?.message, 'success')
            getCommissionDetails()

        } catch (error) {
            Snackbar("Network error", 'error')
        }
    }

    useEffect(() => {
        if (triggerApi) {
            getCommissionDetails()
            setTriggerApi(false)
        }
    }, [rowsPerPage, page, triggerApi])

    const onSubmit = () => {

    }

    const onProceed = () => {

    }

    const viewReferralTypeList = async (item) => {
        setReferralTypeOpen(true)
        try {
            const payload = {
                referralCommissionId: item?.referralCommissionId
            }
            const response = await viewReferralPaymentList(payload).unwrap();
            setReferralPayment(response?.response)

        } catch (error) {
            Snackbar("Network error", 'error')
        }

    }

    const handleCancel = async () => {

        try {
            if (!rejectReason) {
                return;
            } else {
                const payload = {
                    referralCommissionId: refundList?.referralCommissionId,
                    referralCommissionPaymentId: selectedIds,
                    reasonForCancellation: rejectReason,
                }

                const response = await paymentRefund(payload).unwrap();
                Snackbar(response?.response?.message, 'success')
                getCommissionDetails();
                setMinihistoryDialogOpen(false)
                setRejectReason('')
            }

        } catch (error) {
            Snackbar("Network error", 'error')
        }

    }



    return (
        <Box className="container">
            <Grid2 item sx={{ display: 'flex', alignItems: 'center', color: '#6941C6', gap: '4px', cursor: 'pointer', width: '40px', marginBottom: '20px' }} onClick={handleNavigation}>
                <ArrowBackIcon sx={{ fontSize: '17px' }} />
                <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>Back</Typography>
            </Grid2>


            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', flexWrap: 'wrap', alignItems: 'flex-start' }}>
                <Box>
                    <Typography className='title'>{positionName}</Typography>
                    <Typography sx={{ fontSize: '14px' }} >{clientId} {clientName}</Typography>

                </Box>

                <Box>
                    <Typography sx={{ fontSize: '14px' }} ><span className="title" style={{ color: '#53389E' }}>{recruiterId} </span><span className="title">{recruitersName}</span><br></br>{recruiterEmail}</Typography>

                </Box>



                {/* <MUICancelButton title="Make Payment"
                    sx={{ border: '1px solid #7F56D9', color: '#ffffff', backgroundColor: '#7F56D9', width: '150px' }}
                    startIcon={<AddIcon />}
                    onClick={handleOpenPaymentDialog}
                ></MUICancelButton> */}
            </Box >

            <Box sx={{ width: '100%', typography: 'body2' }}>
                {/* postion name  */}
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList
                            onChange={handleChange}
                            aria-label="Overview and Candidates tabs"
                            textColor="primary"
                            indicatorColor="secondary"
                        >
                            <Tab
                                label="Commissions"
                                value="1"
                                className="tabs"
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: value === "1" ? 'bold' : 'normal',
                                    transition: 'all 0.3s ease',
                                }}
                            />

                            {/* <Tab
                                label="Payments"
                                value="2"
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: value === "2" ? 'bold' : 'normal',
                                    transition: 'all 0.3s ease',
                                }}
                            /> */}

                        </TabList>
                    </Box>

                    {/* tabs  */}
                    <TabPanel value="1" sx={{ display: 'flex', padding: 1.5 }}>

                        <Paper sx={{ width: '100%', overflow: 'auto', border: '1px solid #E9EAEB', marginTop: '10px' }} elevation={0}>
                            <Table>
                                <TableHead style={{
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 10,
                                    width: '100%',
                                }}>
                                    <TableRow>
                                        <TableCell className="tableHeadersCell" >S.No</TableCell>
                                        <TableCell className="tableHeadersCell" align='left'>Referral Type</TableCell>
                                        <TableCell className="tableHeadersCell">Joined Candidate </TableCell>
                                        <TableCell className="tableHeadersCell">Joining Date</TableCell>
                                        <TableCell className="tableHeadersCell" align="left"> Annual Salary</TableCell>
                                        <TableCell className="tableHeadersCell"> Commission Earnings</TableCell>
                                        <TableCell className="tableHeadersCell">Created Date</TableCell>
                                        <TableCell className="tableHeadersCell">Status</TableCell>
                                        {
                                            userRole !== "recruiter" && userRole && (
                                                <TableCell className="tableHeadersCell">Action</TableCell>
                                            )
                                        }
                                    </TableRow>
                                </TableHead>

                                {!showTableLoader ? (
                                    CommissionDetails?.length > 0 ? (
                                        CommissionDetails?.map((item, index) => (
                                            <TableRow key={item?.positionId}>
                                                <TableCell className='tableBodyCell' >{index + 1}</TableCell>
                                                <TableCell className='tableBodyCell'>
                                                    <span style={{ color: '#53389E', fontWeight: 600, cursor: "pointer" }} onClick={(e) => viewReferralTypeList(item)}>
                                                        {item?.referralType}-{dayjs(item?.candidateJoiningDate).format('YYYY')}-{item?.referralCommissionId}
                                                    </span>
                                                </TableCell>
                                                <TableCell className='tableBodyCell' >{item?.profileName}</TableCell>
                                                <TableCell className='tableBodyCell'>{dayjs(item?.candidateJoiningDate).format('DD-MM-YYYY')}</TableCell>
                                                <TableCell className='tableBodyCell'>{item?.candidateAnnualSalary}</TableCell>
                                                <TableCell className='tableBodyCell'>
                                                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                        <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                        <Typography sx={{ fontSize: '12.5px' }}>
                                                            {item?.commissionAmount}
                                                        </Typography>
                                                    </Box>
                                                </TableCell>
                                                <TableCell className='tableBodyCell'>{dayjs(item?.createdDate).format('DD-MM-YYYY')}</TableCell>
                                                <TableCell className='tableBodyCell'>
                                                    {item?.status === 'Rejected' ? (
                                                        <Tooltip
                                                            slotProps={{
                                                                tooltip: {
                                                                    sx: {
                                                                        backgroundColor: "#0A0D12",
                                                                        borderRadius: '8px',
                                                                        padding: '8px 12px',
                                                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                    }
                                                                }
                                                            }}
                                                            title={item?.reasonForCancellation} arrow>
                                                            <span className={`status-badge ${item?.status.toLowerCase()}`}>{item?.status}</span>
                                                        </Tooltip>
                                                    ) : (
                                                        <span className={`status-badge ${item?.status.toLowerCase()}`}>{item?.status === "PPAID" ? "Partially Paid" : item?.status === "REJ" ? "Rejected" : item?.status === "REJRFND" ? "Refunded & Rejected" : item?.status === "CLS" ? "Closed" : item?.status === "Pending" ? "Pending" : item?.status === "RRA" && "Refunded & Returned"}</span>
                                                    )}
                                                </TableCell>

                                                {
                                                    userRole !== "recruiter" && userRole && (
                                                        <TableCell className='tableBodyCell' sx={{ fontWeight: 'bold', cursor: 'pointer', display: 'flex', gap: '10px' }}>
                                                            {
                                                                item?.status === "Approved" ?
                                                                    (
                                                                        <Tooltip
                                                                            slotProps={{
                                                                                tooltip: {
                                                                                    sx: {
                                                                                        backgroundColor: "#0A0D12",
                                                                                        borderRadius: '8px',
                                                                                        padding: '8px 12px',
                                                                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                                    }
                                                                                }
                                                                            }}
                                                                            title="Reject">
                                                                            <CloseOutlinedIcon onClick={() => hanldeMiniDialogOpen(item)} sx={{ fontSize: '17px', color: '#D92D20', margin: '5px' }} />
                                                                        </Tooltip>
                                                                    ) : (item?.status === "Rejected" ? (<span className="tableBodyCell">NA</span>) :
                                                                        (<><Tooltip
                                                                            slotProps={{
                                                                                tooltip: {
                                                                                    sx: {
                                                                                        backgroundColor: "#0A0D12",
                                                                                        borderRadius: '8px',
                                                                                        padding: '8px 12px',
                                                                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                                    }
                                                                                }
                                                                            }}
                                                                            title="Approve">
                                                                            <DoneIcon onClick={() => approveReferral(item)} sx={{ fontSize: '17px', color: '#1cbd09', margin: '5px' }} />
                                                                        </Tooltip>
                                                                            <Tooltip
                                                                                slotProps={{
                                                                                    tooltip: {
                                                                                        sx: {
                                                                                            backgroundColor: "#0A0D12",
                                                                                            borderRadius: '8px',
                                                                                            padding: '8px 12px',
                                                                                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                                        }
                                                                                    }
                                                                                }}
                                                                                title="Reject">
                                                                                <CloseOutlinedIcon onClick={() => hanldeMiniDialogOpen(item)} sx={{ fontSize: '17px', color: '#D92D20', margin: '5px' }} />
                                                                            </Tooltip>
                                                                        </>
                                                                        )
                                                                    )
                                                            }
                                                        </TableCell>
                                                    )
                                                }

                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={9}>
                                                    <Typography className="emptydatas">No Data Found</Typography>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    )
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={9}>
                                            <Box className='tableloader'>
                                                <TableLoader />
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                )}
                                <TableRow>{count <= rowsPerPage ? ("") : (
                                    <TableCell colSpan={100}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <MUICancelButton
                                                title='Previous'
                                                startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                                disabled={page === 1}
                                                onClick={() => handleChangePage(null, page - 1)}
                                                sx={{ height: '36px' }}
                                            />
                                            <Pagination
                                                page={page}
                                                onChange={handleChangePage}
                                                count={Math.ceil(count / rowsPerPage)}
                                                siblingCount={3}
                                                boundaryCount={3}
                                                shape="rounded"
                                                hidePrevButton
                                                hideNextButton
                                            />

                                            <MUICancelButton
                                                title='Next'
                                                startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(count / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                                disabled={page === Math.ceil(count / rowsPerPage)}
                                                onClick={() => handleChangePage(null, page + 1)}
                                                sx={{ height: '36px' }}
                                            />

                                        </div>
                                    </TableCell>)
                                }
                                </TableRow>
                            </Table>
                        </Paper>
                    </TabPanel>

                    {/* Second Tabs begining point... */}
                    <TabPanel value="2" sx={{ " &.MuiTabPanel-root": { padding: 0 } }}>

                    </TabPanel>
                </TabContext>
            </Box>

            <Grid2>
                <Dialog
                    open={paymentDialogOpen}
                    onClose={handleClose}
                    scroll="paper"
                    maxWidth="md"
                    sx={{
                        '& .MuiDialog-paper': {
                            minHeight: '95vh',
                            minWidth: '60vw'
                        },
                        marginLeft: '70px'
                    }}
                >
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography sx={{ fontWeight: 600, fontSize: '18px', marginLeft: '5%' }}>Make Payment</Typography>
                        <CloseIcon onClick={() => setPaymentDialogOpen(false)} sx={{ cursor: 'pointer' }} />
                    </DialogTitle>
                    <DialogContent>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <DialogContentText>
                                <Grid2 item sx={{ display: "flex", flexDirection: 'row', justifyContent: 'space-between', }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '50%', alignItems: 'center' }} rowGap={2}>
                                        <Box sx={{ width: '80%' }}>
                                            <InputLabel className='inputlabels'>Job Position <span style={{ color: 'red' }}>*</span></InputLabel>
                                            <Controller
                                                control={control}
                                                name="jobPosition"
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        type='text'
                                                        placeholder="Enter Job Position"
                                                        variant="outlined"
                                                        size="small"
                                                        className='textfields'
                                                        autoComplete="off"
                                                        onWheel={(e) => e.target.blur()}
                                                    />
                                                )}
                                            />
                                            {errors?.jobPosition?.message && (
                                                <div style={{ color: 'red', fontSize: '0.7rem' }}>
                                                    {errors?.jobPosition?.message}
                                                </div>
                                            )}

                                        </Box>

                                        <Box sx={{ width: '80%' }}>
                                            <InputLabel className='inputlabels'>Reward Price <span style={{ color: 'red' }}>*</span></InputLabel>
                                            <TextField
                                                type='number'
                                                placeholder="Enter Referral Price"
                                                variant="outlined"
                                                size="small"
                                                className='textfields'
                                                autoComplete="off"
                                                onWheel={(e) => e.target.blur()}
                                            />
                                        </Box>

                                        <Box sx={{ width: '80%' }}>
                                            <InputLabel className='inputlabels'>Joined Candidate <span style={{ color: 'red' }}>*</span></InputLabel>
                                            <Dropdown
                                                className="dropdown"
                                                placeholder="Select Candidate"

                                            />

                                        </Box>

                                        <Box sx={{ width: '80%' }}>
                                            <InputLabel className='inputlabels'>Candidate Joining Date <span style={{ color: 'red' }}>*</span></InputLabel>
                                            <MuiDatePicker
                                                slots={{
                                                    openPickerIcon: CalendarIcon
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        size: 'small',
                                                        placeholder: 'Candidate Joining Date',
                                                        InputProps: { sx: { borderRadius: '10px', height: '35px' } }
                                                    }
                                                }}
                                                value={JoiningDate}
                                                onChange={handleCandidateDate}
                                                sx={{
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '14px'
                                                    },
                                                    "& .MuiSvgIcon-root": {
                                                        fontSize: '20px'
                                                    }
                                                }}
                                                format="DD-MM-YYYY"
                                                onWheel={(e) => e.target.blur()}

                                            />
                                        </Box>

                                        <Box sx={{ width: '80%' }}>
                                            <InputLabel className='inputlabels'>Referred By </InputLabel>
                                            <TextField
                                                type='text'
                                                placeholder="Enter Referred By "
                                                variant="outlined"
                                                size="small"
                                                className='textfields'
                                                autoComplete="off"
                                                onWheel={(e) => e.target.blur()}

                                            />
                                        </Box>

                                    </Box>

                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '50%', alignItems: 'center' }} rowGap={2}>
                                        <Box sx={{ width: '80%' }}>
                                            <InputLabel className='inputlabels'>Reward Type<span style={{ color: 'red' }}>*</span></InputLabel>
                                            <TextField
                                                type='text'
                                                placeholder="Enter Reward Type"
                                                variant="outlined"
                                                size="small"
                                                className='textfields'
                                                autoComplete="off"
                                                onWheel={(e) => e.target.blur()}
                                            />
                                        </Box>

                                        <Box sx={{ width: '80%' }}>
                                            <InputLabel className='inputlabels'>Reward Percentage<span style={{ color: 'red' }}>*</span></InputLabel>
                                            <TextField
                                                type='number'
                                                placeholder="Enter Reward Percentage "
                                                variant="outlined"
                                                size="small"
                                                className='textfields'
                                                autoComplete="off"
                                                onWheel={(e) => e.target.blur()}
                                            />
                                        </Box>

                                        <Box sx={{ width: '80%' }}>
                                            <InputLabel className='inputlabels'>Candidate Annual Salary <span style={{ color: 'red' }}>*</span></InputLabel>
                                            <TextField
                                                type='number'
                                                placeholder="Enter Candidate Annual Salary"
                                                variant="outlined"
                                                size="small"
                                                className='textfields'
                                                autoComplete="off"
                                                onWheel={(e) => e.target.blur()}

                                            />
                                        </Box>

                                        <Box sx={{ width: '80%' }}>
                                            <InputLabel className='inputlabels'>Referral Commissions <span style={{ color: 'red' }}>*</span></InputLabel>
                                            <TextField
                                                type='number'
                                                placeholder="Enter Referral Commissions"
                                                variant="outlined"
                                                size="small"
                                                className='textfields'
                                                autoComplete="off"
                                                onWheel={(e) => e.target.blur()}
                                            />
                                        </Box>

                                        <Box sx={{ width: '80%' }}>
                                            <InputLabel className='inputlabels'>Other Deductions</InputLabel>
                                            <TextField
                                                type='number'
                                                placeholder="Enter Deduction Amount"
                                                variant="outlined"
                                                size="small"
                                                className='textfields'
                                                autoComplete="off"
                                                onWheel={(e) => e.target.blur()}
                                            />
                                        </Box>
                                    </Box>

                                </Grid2>

                                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', marginTop: '15px', }}>
                                    <Box sx={{ width: '90%', }}>
                                        <InputLabel className='inputlabels'>Reason</InputLabel>
                                        <textarea
                                            size="small" style={{
                                                width: '100%',
                                                height: '70px',
                                                fontSize: '14px',
                                                paddingTop: '5px',
                                                paddingLeft: '10px',
                                                fontFamily: 'Arial, Helvetica, sans-serif',
                                                boxSizing: 'border-box',
                                                borderRadius: '10px',
                                                border: '1px solid #ced4da',
                                                resize: 'none'
                                            }}
                                            className='textareas'
                                            placeholder="Enter Reason"
                                        />
                                    </Box>
                                </Box>

                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: '10px', }} rowGap={2}>
                                    <Box sx={{ width: '40%' }}>
                                        <InputLabel className='inputlabels'>Net Pay <span style={{ color: 'red' }}>*</span></InputLabel>
                                        <TextField
                                            type='number'
                                            placeholder="Enter Net Pay Amount"
                                            variant="outlined"
                                            size="small"
                                            className='textfields'
                                            autoComplete="off"
                                            onWheel={(e) => e.target.blur()}
                                        />
                                    </Box>

                                    <Box sx={{ width: '40%' }}>
                                        <InputLabel className='inputlabels'>Total Amount <span style={{ color: 'red' }}>*</span></InputLabel>
                                        <TextField
                                            type='number'
                                            placeholder="Enter Total Amount"
                                            variant="outlined"
                                            size="small"
                                            className='textfields'
                                            autoComplete="off"
                                            onWheel={(e) => e.target.blur()}
                                        />
                                    </Box>

                                </Box>

                                <DialogActions>
                                    <Grid2 item sx={{ marginTop: '25px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                        <MUICancelButton title="Cancel" onClick={() => setPaymentDialogOpen(false)} />
                                        <MUIButton title='Proceed' type='submit' sx={{ borderRadius: '7px', width: '130px' }} />
                                    </Grid2>
                                </DialogActions>
                            </DialogContentText>
                        </form>
                    </DialogContent>
                </Dialog>
            </Grid2>
            {/* Commissions dialob box */}
            <Grid2>
                <Dialog
                    open={CommissionDialogOpen}
                    onClose={handleClose}
                    scroll="paper"
                    maxWidth="md"
                    sx={{
                        '& .MuiDialog-paper': {
                            minHeight: '75vh',
                            minWidth: '55vw'
                        },
                        marginLeft: '70px'
                    }}
                >
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography sx={{ fontWeight: 600, fontSize: '18px', marginLeft: '5%' }}>Make Commissions</Typography>
                        <CloseIcon onClick={() => setCommissionsDialogOpen(false)} sx={{ cursor: 'pointer' }} />
                    </DialogTitle>
                    <DialogContent>
                        <form onSubmit={handleSubmit(onProceed)}>
                            <DialogContentText>
                                <Grid2 item sx={{ display: "flex", flexDirection: 'row', justifyContent: 'space-between', }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '50%', alignItems: 'center' }} rowGap={2}>
                                        <Box sx={{ width: '80%' }}>
                                            <InputLabel className='inputlabels'>Job Name <span style={{ color: 'red' }}>*</span></InputLabel>
                                            <Controller
                                                control={control}
                                                name="jobPosition"
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        type='text'
                                                        placeholder="Enter Job Position"
                                                        variant="outlined"
                                                        size="small"
                                                        className='textfields'
                                                        autoComplete="off"
                                                        onWheel={(e) => e.target.blur()}
                                                    />
                                                )}
                                            />
                                            {errors?.jobPosition?.message && (
                                                <div style={{ color: 'red', fontSize: '0.7rem' }}>
                                                    {errors?.jobPosition?.message}
                                                </div>
                                            )}

                                        </Box>

                                        <Box sx={{ width: '80%' }}>
                                            <InputLabel className='inputlabels'>Balance Amount <span style={{ color: 'red' }}>*</span></InputLabel>
                                            <TextField
                                                type='number'
                                                placeholder="Enter Business Associate"
                                                variant="outlined"
                                                size="small"
                                                className='textfields'
                                                autoComplete="off"
                                                onWheel={(e) => e.target.blur()}
                                            />
                                        </Box>

                                        <Box sx={{ width: '80%' }}>
                                            <InputLabel className='inputlabels'>TDS (%)</InputLabel>
                                            <TextField
                                                type='text'
                                                placeholder="Enter TDS% "
                                                variant="outlined"
                                                size="small"
                                                className='textfields'
                                                autoComplete="off"
                                                onWheel={(e) => e.target.blur()}

                                            />
                                        </Box>

                                    </Box>

                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '50%', alignItems: 'center' }} rowGap={2}>
                                        <Box sx={{ width: '80%' }}>
                                            <InputLabel className='inputlabels'>Business Associate <span style={{ color: 'red' }}>*</span></InputLabel>
                                            <TextField
                                                type='text'
                                                placeholder="Enter Reward Type"
                                                variant="outlined"
                                                size="small"
                                                className='textfields'
                                                autoComplete="off"
                                                onWheel={(e) => e.target.blur()}
                                            />
                                        </Box>

                                        <Box sx={{ width: '80%' }}>
                                            <InputLabel className='inputlabels'>Payment Amount<span style={{ color: 'red' }}>*</span></InputLabel>
                                            <TextField
                                                type='number'
                                                placeholder="Enter Reward Percentage "
                                                variant="outlined"
                                                size="small"
                                                className='textfields'
                                                autoComplete="off"
                                                onWheel={(e) => e.target.blur()}
                                            />
                                        </Box>

                                        <Box sx={{ width: '80%' }}>
                                            <InputLabel className='inputlabels'>TDS Amount <span style={{ color: 'red' }}>*</span></InputLabel>
                                            <TextField
                                                type='number'
                                                placeholder="Enter Candidate Annual Salary"
                                                variant="outlined"
                                                size="small"
                                                className='textfields'
                                                autoComplete="off"
                                                onWheel={(e) => e.target.blur()}

                                            />
                                        </Box>
                                    </Box>
                                </Grid2>

                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: '10px', }} rowGap={2}>
                                    <Box sx={{ width: '40%' }}>
                                        <InputLabel className='inputlabels'>Other Deductions <span style={{ color: 'red' }}>*</span></InputLabel>
                                        <TextField
                                            type='number'
                                            placeholder="Enter Total Amount"
                                            variant="outlined"
                                            size="small"
                                            className='textfields'
                                            autoComplete="off"
                                            onWheel={(e) => e.target.blur()}
                                        />
                                    </Box>

                                    <Box sx={{ width: '40%' }}>
                                        <InputLabel className='inputlabels'>Net Pay <span style={{ color: 'red' }}>*</span></InputLabel>
                                        <TextField
                                            type='number'
                                            placeholder="Enter Net Pay Amount"
                                            variant="outlined"
                                            size="small"
                                            className='textfields'
                                            autoComplete="off"
                                            onWheel={(e) => e.target.blur()}
                                        />
                                    </Box>

                                </Box>

                                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', marginTop: '15px', }}>
                                    <Box sx={{ width: '90%', }}>
                                        <InputLabel className='inputlabels'>Reason</InputLabel>
                                        <textarea
                                            size="small" style={{
                                                width: '100%',
                                                height: '70px',
                                                fontSize: '14px',
                                                paddingTop: '5px',
                                                paddingLeft: '10px',
                                                fontFamily: 'Arial, Helvetica, sans-serif',
                                                boxSizing: 'border-box',
                                                borderRadius: '10px',
                                                border: '1px solid #ced4da',
                                                resize: 'none'
                                            }}
                                            className='textareas'
                                            placeholder="Enter Reason"
                                        />
                                    </Box>
                                </Box>

                                <DialogActions>
                                    <Grid2 item sx={{ marginTop: '25px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                        <MUICancelButton title="Cancel" onClick={() => setCommissionsDialogOpen(false)} />
                                        <MUIButton title='Proceed' type='submit' sx={{ borderRadius: '7px', width: '130px' }} />
                                    </Grid2>
                                </DialogActions>
                            </DialogContentText>
                        </form>
                    </DialogContent>
                </Dialog>

                <Grid2 item>
                    <Dialog
                        open={MinihistoryDialogOpen}
                        scroll="paper"
                        maxWidth="xs"
                        sx={{
                            "& .MuiDialog-paper": {
                                width: '90%',
                                maxWidth: '550px',
                                height: 'auto',
                                borderRadius: '15px'
                            },
                        }}
                    >
                        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '18px', fontWeight: 550 }}>
                            Refund
                            <CloseIcon sx={{ color: '#717680', cursor: 'pointer' }} onClick={handleClose} />
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow >
                                                <TableCell className='tableHeadersCell'>S.No </TableCell>
                                                <TableCell className='tableHeadersCell'>Due Date </TableCell>
                                                <TableCell className='tableHeadersCell'>Amount </TableCell>
                                                <TableCell className='tableHeadersCell'>Status</TableCell>
                                                <TableCell className='tableHeadersCell'>Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {referralPayment?.length > 0 ? (
                                            <TableBody>
                                                {referralPayment?.map((item, index) => {

                                                    return (
                                                        <TableRow
                                                            key={index}
                                                            sx={{
                                                                backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                                '&:hover': { backgroundColor: '#f1f1f1' },
                                                            }}
                                                        >
                                                            <TableCell className='tableBodyCell'>{index + 1}</TableCell>
                                                            <TableCell className='tableBodyCell'>{dayjs(item?.paymentDate).format('DD-MM-YYYY')}</TableCell>
                                                            <TableCell className='tableBodyCell'>
                                                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                    <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                    <Typography sx={{ fontSize: '12.5px' }}>
                                                                        {item.paymentAmount}
                                                                    </Typography>
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell className='tableBodyCell'>{item.paymentStatus}</TableCell>
                                                            <TableCell className='tableBodyCell'><Checkbox disabled={item.paymentStatus === 'Pending'} checked={selectedIds?.includes(item.referralCommissionPaymentId)} onChange={() => handleCheckboxChange(item.referralCommissionPaymentId)} /></TableCell>
                                                        </TableRow>
                                                    )
                                                })
                                                }
                                            </TableBody>
                                        ) : (<TableBody>
                                            <TableRow>
                                                <TableCell colSpan={5}>
                                                    <Typography className="emptydatas">No Data Found</Typography>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                        )}
                                    </Table>
                                </TableContainer>
                                <Grid2 item sx={{ width: '100%', marginTop: '20px' }}>
                                    <InputLabel className="inputlabels">Reason for Rejection</InputLabel>
                                    <textarea
                                        className="jobPostingTextAreas"
                                        style={{ width: '100%', resize: 'none', borderRadius: '7px', color: '#535862' }}
                                        value={rejectReason}
                                        onChange={handleReject}
                                        placeholder="Enter reason for reject"
                                    />
                                    {
                                        !rejectReason ? (<span style={{ color: 'red', fontSize: '0.8rem' }}>Reason is required</span>) : ("")
                                    }
                                </Grid2>
                                <Grid2 item sx={{ marginTop: '25px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                    <MUICancelButton title='Close' onClick={(e) => {
                                        setMinihistoryDialogOpen(false);
                                        setRejectReason('');
                                    }}
                                    />
                                    <MUIButton title='Submit' sx={{ backgroundColor: '#D92D20', borderRadius: '10px', cursor: 'pointer' }} onClick={handleCancel} />
                                </Grid2>
                            </DialogContentText>
                        </DialogContent>
                    </Dialog>
                </Grid2>
            </Grid2>

            <Grid2>
                <Dialog
                    open={referralTypeOpen}
                    scroll="paper"
                    maxWidth="md"
                    onClose={handleClose}
                    sx={{
                        "& .MuiDialog-paper": {
                            minWidth: '60vw',
                            minHeight: '75vh'
                        },
                    }}
                >
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '18px', fontWeight: 550 }}>
                        Payment History
                        <CloseIcon sx={{ color: '#717680', cursor: 'pointer' }} onClick={handleClose} />
                    </DialogTitle>
                    <DialogContent dividers>

                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow >
                                        <TableCell className='tableHeadersCell'>S.No </TableCell>
                                        <TableCell className='tableHeadersCell'>Due Date </TableCell>
                                        <TableCell className='tableHeadersCell'>Amount </TableCell>
                                        <TableCell className='tableHeadersCell'>Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                {referralPayment?.length > 0 ? (
                                    <TableBody>
                                        {referralPayment?.map((item, index) => {

                                            return (
                                                <TableRow
                                                    key={index}
                                                    sx={{
                                                        backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                        '&:hover': { backgroundColor: '#f1f1f1' },
                                                    }}
                                                >
                                                    <TableCell className='tableBodyCell'>{index + 1}</TableCell>
                                                    <TableCell className='tableBodyCell'>{dayjs(item?.paymentDate).format('DD-MM-YYYY')}</TableCell>
                                                    <TableCell className='tableBodyCell'>
                                                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                            <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                            <Typography sx={{ fontSize: '12.5px' }}>
                                                                {item.paymentAmount}
                                                            </Typography>
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell className='tableBodyCell'>
                                                        {item?.paymentStatus === 'Rejected' ? (
                                                            <Tooltip
                                                                slotProps={{
                                                                    tooltip: {
                                                                        sx: {
                                                                            backgroundColor: "#0A0D12",
                                                                            borderRadius: '8px',
                                                                            padding: '8px 12px',
                                                                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                        }
                                                                    }
                                                                }}
                                                                title={item?.reasonForRejection} arrow>
                                                                <span>{item?.paymentStatus}</span>
                                                            </Tooltip>
                                                        ) : (
                                                            <span>{item?.paymentStatus}</span>
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })
                                        }
                                    </TableBody>
                                ) : (<TableBody>
                                    <TableRow>
                                        <TableCell colSpan={4}>
                                            <Typography className="emptydatas">No Data Found</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                                )}
                            </Table>
                        </TableContainer>
                    </DialogContent>
                    <DialogActions>
                        <MUICancelButton onClick={handleClose} title='Close'></MUICancelButton>
                    </DialogActions>
                </Dialog>
            </Grid2>


        </Box>
    )
}

export default ViewPayments